import React, {createContext, useCallback, useContext, useState} from 'react';
import PropTypes from 'prop-types';
import defaultConfig from './defaultConfig';
import { messageService } from '@crema/services/auth/firebase/FirebaseAuthProvider';
import {take} from 'rxjs/operators';
const SidebarContext = createContext();
const SidebarActionsContext = createContext();
let sidebar_settings = sessionStorage.getItem("sidebar_settings") ? JSON.parse(sessionStorage.getItem("sidebar_settings")) : '';
console.debug('COBA ANR ',sidebar_settings);
let sidebar_data;
if (sidebar_settings?.menuStyle){
  sidebar_data = {
    menuStyle:sidebar_settings.menuStyle,
    colorSet:sidebar_settings.colorSet,
    isSidebarBgImage:sidebar_settings.isSidebarBgImage,
    sidebarBgImage:sidebar_settings.sidebarBgImage
  }
}else{
  sidebar_data = {
    menuStyle:defaultConfig.sidebar.menuStyle,
    colorSet:defaultConfig.sidebar.colorSet,
    isSidebarBgImage:defaultConfig.sidebar.isSidebarBgImage,
    sidebarBgImage:defaultConfig.sidebar.sidebarBgImage,
  }
}

export const useSidebarContext = () => useContext(SidebarContext);

export const useSidebarActionsContext = () => useContext(SidebarActionsContext);

const SidebarContextProvider = ({children}) => {
  messageService.getMessage().pipe(take(1)).subscribe(message => {
    if (message.text[0]){
      const sidebar_settings = JSON.parse(message.text[0]);
      sidebar_data = {
        menuStyle: sidebar_settings.menuStyle,
        colorSet: sidebar_settings.colorSet,
        isSidebarBgImage: sidebar_settings.isSidebarBgImage,
        sidebarBgImage: sidebar_settings.sidebarBgImage
      }
      setSideBarData(sideBarData);
      updateMenuStyle(sidebar_data.menuStyle);
      updateSidebarColorSet(sidebar_data.colorSet);
      updateImage(sidebar_data.isSidebarBgImage);
      setSidebarImage(sidebar_data.sidebarBgImage);
    }
  });

  const [sideBarData,setSideBarData] = useState(
   sidebar_data
  );
  const [menuStyle, updateMenuStyle] = useState(
    sidebar_data.menuStyle
  );
  const [sidebarColorSet, updateSidebarColorSet] = useState(
    sidebar_data.colorSet
  );
  const [isSidebarBgImage, updateImage] = useState(
    sidebar_data.isSidebarBgImage
  );
  const [sidebarBgImage, setSidebarImage] = useState(
    sidebar_data.sidebarBgImage
  );

  const setSidebarBgImage = useCallback((isSidebarBgImage) => {
    updateImage(isSidebarBgImage);
  }, []);

  const updateSidebarBgImage = useCallback((sidebarBgImage) => {
    setSidebarImage(sidebarBgImage);
  }, []);

  return (
    <SidebarContext.Provider
      value={{
        ...sidebarColorSet,
        menuStyle,
        isSidebarBgImage,
        sidebarBgImage,
        borderColor: defaultConfig.sidebar.borderColor,
        sideBarData:sideBarData
      }}
    >
      <SidebarActionsContext.Provider
        value={{
          updateMenuStyle,
          updateSidebarColorSet,
          setSidebarBgImage,
          updateSidebarBgImage,
          setSideBarData
        }}
      >
        {children}
      </SidebarActionsContext.Provider>
    </SidebarContext.Provider>
  );
};

export default SidebarContextProvider;

SidebarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
